module.exports = __webpack_public_path__ + "static/media/Information Circle.857fa349.svg";